<div class="desktop-redirect-container" *ngIf="isDesktop">
  <div class="redirect-card">
    <div class="icon-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="3" ry="3"></rect>
        <line x1="12" y1="18" x2="12.01" y2="18"></line>
      </svg>
    </div>

    <span class="badge-mobile">Experiencia Móvil Exclusiva</span>

    <h2 class="title">Accede desde tu dispositivo móvil</h2>
    
    <p class="description">
      Detectamos que estás navegando desde una computadora. Este servicio está diseñado para ser utilizado de manera óptima a través de nuestra <strong>aplicación móvil oficial</strong>.
    </p>

    <div class="store-links-container">
      <p class="store-title">Descarga la App en tu celular:</p>
      <div class="badges-wrapper">
        <a [href]="URL_ANDROID" target="_blank" rel="noopener noreferrer" class="store-badge">
          <img src="assets/img/appstore-badges/google-play-badge.png" alt="Disponible en Google Play">
        </a>
        <a [href]="URL_IOS" target="_blank" rel="noopener noreferrer" class="store-badge">
          <img src="assets/img/appstore-badges/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg" alt="Consíguelo en el App Store">
        </a>
      </div>
    </div>

    <div class="divider"></div>

    <div class="footer-actions">
      <button class="btn-home" (click)="irAHome()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        Ir al sitio web principal
      </button>
    </div>
  </div>
</div>
